/**
 * Calls a function the embedding page exposed on `window` under the name a widget param
 * carries. Async on purpose: the host's code must never run inside the widget's render.
 */
export const callHostFunction = (name: string | undefined | null, ...args: unknown[]): void => {
  if (!name) {
    return;
  }

  const candidate = (window as unknown as Record<string, unknown>)[name];

  if (typeof candidate !== 'function') {
    return;
  }

  const hostFunction = candidate as (...hostArgs: unknown[]) => void;

  setTimeout(() => {
    try {
      hostFunction(...args);
    } catch (error) {
      // Host callbacks are best-effort; a seller page bug must not break checkout.
      console.error('Error calling host function', error);
    }
  }, 0);
};
